import React from 'react';

import { TranslateFunction } from 'react-localize-redux';

import { Button } from '../../atoms/Button/Button';

export interface ReceiptButtonProps {
  receiptButtonStatus?: 'default' | 'loading' | 'disabled';
  receiptCode?: string;
  translate: TranslateFunction;
  variant?: 'primary' | 'secondary';
}

export function ReceiptButton(props: ReceiptButtonProps): JSX.Element {
  const {
    receiptButtonStatus = 'default',
    receiptCode = null,
    translate,
    variant = 'primary',
  } = props;

  return (
    <Button
      disabled={!receiptCode}
      href={`https://receipt.link/${receiptCode}`}
      rel="noopener noreferrer"
      status={receiptButtonStatus}
      target="_blank"
      variant={variant}
    >
      {translate('Checkout_viewReceipt')}
    </Button>
  );
}
